import PropTypes from 'prop-types';
import { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { bindActionCreators } from 'redux';
// eslint-disable-next-line no-restricted-imports
import { Button, Segment } from 'semantic-ui-react';

import { routes } from '../../../../../config/routes';
import { resetPaymentData } from '../../../../../redux/actions/billingActions';
import Step from './Step';

import { SEGMENT_EVENTS } from '../../../../../segment';
import withSegmentHook from '../../../../../segment/hooks/withSegmentHook';
import './Steps.scss';

class Steps extends Component {
  static propTypes = {
    activeStep: PropTypes.number,
    loading: PropTypes.bool,
    isInvoice: PropTypes.bool,
  };

  state = {
    steps: [
      {
        link: routes.billing.invoices.edit,
        label: this.props.t('billing.invoiceCreation.steps.detailsLabel'),
        step: 1,
      },
      {
        link: routes.billing.select,
        label: this.props.t('billing.invoiceCreation.steps.studentsLabel'),
        step: 2,
      },
      {
        link: routes.billing.confirm,
        label: this.props.t('billing.invoiceCreation.steps.confirmLabel'),
        step: 3,
      },
    ],
    activeStep: 1,
    isConfirm: false,
  };

  componentDidMount() {
    let activeStep = this.state.steps.filter((step) => step && step.link === this.props.location.pathname);

    activeStep = activeStep && activeStep.length ? activeStep[0].step : '';

    this.setState({
      activeStep,
      isConfirm: activeStep === 3,
    });
  }
  getIsInvoice() {
    return this.props.isInvoice ?? this.props.paymentDetails?.isInvoice ?? true;
  }
  render() {
    let { activeStep, steps, isConfirm } = this.state;
    let { t, paymentDetails, paymentEmployees, loading, navigate, disabled, firstInvoiceCreated, segmentTrack } =
      this.props;

    let disableBtn = disabled;
    if (isConfirm && (!paymentDetails || !paymentEmployees || !paymentEmployees.length)) {
      disableBtn = true;
    }

    const actionButtonContent = isConfirm
      ? this.getIsInvoice()
        ? t('billing.invoiceCreation.actions.sendInvoice')
        : t('billing.invoiceCreation.actions.createPlan')
      : t('billing.invoiceCreation.actions.next');

    return (
      <Segment className="margin bottom">
        <div className={'step-container'}>
          {steps.map((step, index) => {
            let stepIndex = index + 1;
            let disabled = false;
            if (
              ((!paymentDetails || (paymentDetails && paymentDetails.total < 0)) && stepIndex === 2) ||
              ((!paymentDetails || !paymentEmployees || !paymentEmployees.length) && stepIndex === 3)
            ) {
              disabled = true;
            }
            return (
              <Step
                isActive={stepIndex === activeStep}
                disabled={disabled}
                step={stepIndex}
                label={step.label}
                link={step.link}
                key={`step${index}`}
              />
            );
          })}
        </div>

        <br />
        <Button
          data-testid="create-invoice-next-button"
          disabled={disableBtn}
          loading={loading}
          size="large"
          primary
          fluid
          content={actionButtonContent}
        />

        <br />
        <Button
          data-testid="create-invoice-cancel-button"
          disabled={disableBtn}
          loading={loading}
          size="large"
          basic
          fluid
          content={t('common.cancel')}
          onClick={(e) => {
            e.preventDefault();
            this.props.resetPaymentData();
            if (!firstInvoiceCreated) {
              segmentTrack(SEGMENT_EVENTS.firstInvoiceCancel);
            }
            if (this.getIsInvoice()) navigate(routes.billing.invoices.list);
            else navigate(routes.billing.plans.list);
          }}
        />
      </Segment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    paymentDetails: state.paymentDetails,
    paymentEmployees: state.paymentEmployees,
    firstInvoiceCreated: state.organizations.currentOrganization?.setup?.firstInvoiceCreated,
  };
};
const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      resetPaymentData,
    },
    dispatch
  );
};

// HOC wrapper to provide navigation and location hooks to class component
function withRouterHooks(Component) {
  return function WrappedComponent(props) {
    const navigate = useNavigate();
    const location = useLocation();
    return <Component {...props} navigate={navigate} location={location} />;
  };
}

export default withTranslation()(withSegmentHook(withRouterHooks(connect(mapStateToProps, mapDispatchToProps)(Steps))));
